export const reportCenterRoutes = {
  name: 'reportCenter',
  path: '/report-center',
  component: () => import('pages/ReportCenter/index.vue'),
  meta: {
    title: 'Report Center',
  },
}
